import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ClientTagSelect from './ClientTagSelect'

const useStyles = makeStyles((theme) => ({
  tagDisplay: {
    '& th': {
      backgroundColor: theme.palette.gray.main,
      padding: '10px',
      minWidth: '300px'
    },
    '& td': {
      padding: '10px',
      minWidth: '300px'
    },
    '& .__not-assigned': {
      color: theme.palette.gray.darker
    },
    '& .__remove-button': {
      textTransform: 'none'
    },
    '& .__select-option': {
      minWidth: '300px'
    },
    '& .__select-group': {
      display: 'flex',
      flexDirection: 'row',
      gap: '20px'
    }
  },
  group: {
    lineHeight: '50px',
    '& > *:first-child': {
      backgroundColor: theme.palette.gray.main
    }
  },
  groupType: {
    fontSize: theme.typography.fontSizes.xl,
    fontWeight: theme.typography.weights.semibold
  },
  groupName: {
    fontSize: theme.typography.fontSizes.xl,
    fontWeight: theme.typography.weights.light
  }
}))

const useFormValues = (groupTypes, editing) => {
  const defaultValues = useMemo(() => {
    return {
      groups: groupTypes.map(x => ({
        groupId: x.assigned?.groupId,
        groupTypeId: x.groupTypeId
      }))
    }
  }, [groupTypes])

  const [formValues, setFormValues] = useState(defaultValues)
  useEffect(() => {
    setFormValues(defaultValues)
  }, [setFormValues, defaultValues, editing])

  return {
    formValues,
    setFormValues
  }
}

const ClientTagDisplay = forwardRef(function ClientTagDisplay ({ groups, editing }, ref) {
  const classes = useStyles()
  const { formValues, setFormValues } = useFormValues(groups, editing)
  useImperativeHandle(ref, () => {
    return {
      formValues
    }
  }, [formValues])

  if (editing) {
    return (
      <table className={classes.tagDisplay}>
        <thead>
          <tr>
            <th>Tag Type</th>
            <th>Tag Value</th>
          </tr>
        </thead>
        <tbody>
          {(groups).map(gt => (
            <tr className={classes.group} key={gt.groupTypeId}>
              <td className={classes.groupType}>{gt.longName}</td>
              <td className={classes.groupName}>
                <ClientTagSelect
                  groupType={gt}
                  formValues={formValues}
                  setFormValues={setFormValues}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <table className={classes.tagDisplay}>
      <thead>
        <tr>
          <th>Tag Type</th>
          <th>Tag Value</th>
        </tr>
      </thead>
      <tbody>
        {(groups).map(gt => (
          <tr className={classes.group} key={gt.groupTypeId}>
            <td className={classes.groupType}>{gt.longName}</td>
            <td className={classes.groupName}>
              {gt.assigned ? (
                <span>{gt.assigned.longName}</span>
              ) : (
                <span className='__not-assigned'>&lt;Not Assigned&gt;</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
})

ClientTagDisplay.propTypes = {
  groups: PropTypes.array,
  editing: PropTypes.bool
}

ClientTagDisplay.defaultProps = {
  groups: [],
  editing: false
}

export default ClientTagDisplay
